(function () {
  function initSpacePicker() {
    var buttons = document.querySelectorAll('[data-select-space]');
    if (!buttons.length) return;
    buttons.forEach(function (btn) {
      if (btn.__ffevBound) return;
      btn.__ffevBound = true;
      btn.addEventListener('click', function () {
        var value = btn.dataset.selectSpace;
        var input = document.querySelector('.ffev-space-input[value="' + value + '"]');
        if (!input) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        var form = document.querySelector('.ffev-form');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(function () { input.focus({ preventScroll: true }); }, 350);
      });
    });
  }

  function initFaqAccordion(root) {
    var groups = root.querySelectorAll('.ffev-vfaq-list, .ffe2-faq-list');
    groups.forEach(function (list) {
      var items = list.querySelectorAll('details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  function boot() {
    initSpacePicker();
    document.querySelectorAll('.ffev-root').forEach(initFaqAccordion);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    initSpacePicker();
    var root = e.target.querySelector ? e.target.querySelector('.ffev-root') : null;
    if (root) initFaqAccordion(root);
  });
  if (document.readyState !== 'loading') boot();
})();
